import React from 'react';
import { Modal } from '@hugendubel/react-basic';
import { ArticleDetails } from '../articles/ArticleDetails';
import { ReducedProduct } from '../../../ws/result/ReducedProduct';

const openArticleDetails = (article: ReducedProduct) =>
    Modal.open(<ArticleDetails article={article} close={Modal.close} />, 'modal.articleDetails.title');

export const ModalController = {
    openArticleDetails,
};
